import React, { useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import moment from "moment-timezone";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
} from "@mui/material";
import LoadingScreen from "../../component/LoadingScreen";
import { useDropzone } from "react-dropzone";
import { FaCloudUploadAlt, FaFilePdf } from "react-icons/fa";
import axios from "axios";

function OrderInput() {
  const navigate = useNavigate();
  let [token, setToken] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [orderTypes, setOrderTypes] = useState([]);
  const [orderPriorities, setOrderPriorities] = useState([]);
  // const [isDisabled, setIsDisabled] = useState(false);
  const [customerData, setCustomerData] = useState(null);
  const [customerDataDestination, setCustomerDataDestination] = useState([]);
  const [error, setError] = useState("");
  const [requestorCustomerId, setRequestorCustomerId] = useState();
  const [customerId, setCustomerId] = useState();
  const [orderDate, setOrderDate] = useState("");
  const [locations, setLocations] = useState([]);
  const [cableTypes, setCableTypes] = useState([]);
  const [interfaceData, setInterfaceData] = useState([]);
  const [floors, setFloors] = useState([]);
  const [errorUpload, setErrorUpload] = useState("");

  // Additional state for form inputs
  const [orderType, setOrderType] = useState(1);
  const [orderPriority, setOrderPriority] = useState(1);
  const [picRequestor, setPicRequestor] = useState(null);
  const [picDestination, setPicDestination] = useState(null);
  const [requestorId, setRequestorId] = useState(null);
  const [destinationId, setDestinationId] = useState(null);
  const [companyRequestor, setCompanyRequestor] = useState(null);
  const [companyDestination, setCompanyDestination] = useState(null);
  const [emailRequestor, setEmailRequestor] = useState(null);
  const [emailDestination, setEmailDestination] = useState(null);
  const [selectedOrderTypeId, setSelectedOrderTypeId] = useState(1);
  const [
    isDestinationInformationOtherCompany,
    setIsDestinationInformationOtherCompany,
  ] = useState(true);

  const [selectedPicDestination, setSelectedPicDestination] = useState("");
  const [selectedLocation, setSelectedLocation] = useState("");
  const [companyCodeValuePlaceholder, setCompanyCodeValuePlaceholder] =
    useState("");
  const [companyCodeValue, setCompanyCodeValue] = useState("");
  const [errorCompanyCode, setErrorCompanyCode] = useState("");
  const [isDisabledCompanyCode, setIsDisabledCompanyCode] = useState(false); // State for disabled
  const [isRequiredCompanyCode, setIsRequiredCompanyCode] = useState(true);
  const [openConfirm, setOpenConfirm] = useState(false);
  const [openSuccess, setOpenSuccess] = useState(false);
  const [openFail, setOpenFail] = useState(false);

  const [roomsAend1, setRoomsAend1] = useState([]);
  const [roomsBend1, setRoomsBend1] = useState([]);
  const [roomsAend2, setRoomsAend2] = useState([]);
  const [roomsBend2, setRoomsBend2] = useState([]);
  const [roomsAend3, setRoomsAend3] = useState([]);
  const [roomsBend3, setRoomsBend3] = useState([]);
  const [roomsAend4, setRoomsAend4] = useState([]);
  const [roomsBend4, setRoomsBend4] = useState([]);
  const [roomsAend5, setRoomsAend5] = useState([]);
  const [roomsBend5, setRoomsBend5] = useState([]);
  const AEnd1 = "AEnd1";
  const BEnd1 = "BEnd1";
  const AEnd2 = "AEnd2";
  const BEnd2 = "BEnd2";
  const AEnd3 = "AEnd3";
  const BEnd3 = "BEnd3";
  const AEnd4 = "AEnd4";
  const BEnd4 = "BEnd4";
  const AEnd5 = "AEnd5";
  const BEnd5 = "BEnd5";

  const [aEndInfo, setAEndInfo] = useState({
    cableType: null,
    interface: null,
    floor: null,
    room: null,
    rackId: "",
    cableQuantity: null,
  });

  const [bEndInfo, setBEndInfo] = useState({
    cableType: null,
    interface: null,
    floor: null,
    room: null,
    rackId: "",
  });

  const [aEndInfo2, setAEndInfo2] = useState({
    cableType: null,
    interface: null,
    floor: null,
    room: null,
    rackId: "",
    cableQuantity: null,
  });

  const [bEndInfo2, setBEndInfo2] = useState({
    cableType: null,
    interface: null,
    floor: null,
    room: null,
    rackId: "",
  });

  const [aEndInfo3, setAEndInfo3] = useState({
    cableType: null,
    interface: null,
    floor: null,
    room: null,
    rackId: "",
    cableQuantity: null,
  });

  const [bEndInfo3, setBEndInfo3] = useState({
    cableType: null,
    interface: null,
    floor: null,
    room: null,
    rackId: "",
  });

  const [aEndInfo4, setAEndInfo4] = useState({
    cableType: null,
    interface: null,
    floor: null,
    room: null,
    rackId: "",
    cableQuantity: null,
  });

  const [bEndInfo4, setBEndInfo4] = useState({
    cableType: null,
    interface: null,
    floor: null,
    room: null,
    rackId: "",
  });
  localStorage.getItem("token");
  const [aEndInfo5, setAEndInfo5] = useState({
    cableType: null,
    interface: null,
    floor: null,
    room: null,
    rackId: "",
    cableQuantity: null,
  });

  const [bEndInfo5, setBEndInfo5] = useState({
    cableType: null,
    interface: null,
    floor: null,
    room: null,
    rackId: "",
  });

  const [showXcp2, setShowXcp2] = useState(false);
  const [showXcp3, setShowXcp3] = useState(false);
  const [showXcp4, setShowXcp4] = useState(false);
  const [showXcp5, setShowXcp5] = useState(false);
  let [xcpCount, setXcpCount] = useState(1);
  const [showBtnRemove, setShowBtnRemove] = useState(false);
  const [showBtnAdd, setShowBtnAdd] = useState(true);

  const resource = "input-order";
  const storedToken = localStorage.getItem("token");

  useEffect(() => {
    const checkSessionToken = async () => {
      try {
        const response = await fetch(
          `https://4sx2gdf0k6.execute-api.ap-southeast-3.amazonaws.com/xcp/auth/check-session?token=${storedToken}&resource=${resource}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              authorization: "Basic eGNwOk50dGkyMDI0IQ==",
            },
          }
        );

        if (!response.ok) {
          setError(data.message || "Failed to fetch session token data");
          throw new Error(data.message || "Failed to fetch session token data");
        }

        // Parse response text as a boolean value
        const text = await response.text();
        const data = text === "true";

        if (data) {
        } else {
          window.alert("Session is invalid");
          navigate("/login");
        }
      } catch (error) {
        console.error("Fetch Error:", error.message);
        setError("Fetch Error: " + error.message);
      }
    };

    checkSessionToken();
  }, []);

  useEffect(() => {
    // Retrieve the token from local storage
    const storedToken = localStorage.getItem("token");
    // const storedToken = 'ouU-sQYuTC6ew7Wap0QQG69V3r__Za9aCahiP0ozz87dptRgDvoPWPJm6HXW2sMJ';
    setToken(storedToken);

    // Fetch customer data using the token
    const fetchCustomerData = async () => {
      setIsLoading(true);
      try {
        const response = await fetch(
          `https://4sx2gdf0k6.execute-api.ap-southeast-3.amazonaws.com/xcp/customer/find-by-token?token=${storedToken}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              authorization: "Basic eGNwOk50dGkyMDI0IQ==",
            },
          }
        );

        const data = await response.json();
        if (!response.ok) {
          setError(
            data.message || "Failed to fetch customer d${storedToken}ata"
          );
          throw new Error(data.message || "Failed to fetch customer data");
        }

        setCustomerData(data[0]);
        setRequestorCustomerId(data[0].customer_id);
        //set data
        setRequestorId(data[0].customer_id);
        setCompanyRequestor(data[0].company_name);
        setPicRequestor(data[0].pic_name);
        setEmailRequestor(data[0].email);
      } catch (error) {
        console.error("Fetch Error:", error.message);
        setError("Fetch Error: " + error.message);
      }
      setIsLoading(false);
    };

    fetchCustomerData();
  }, []);

  useEffect(() => {
    const fetchCustomerById = async (customerId) => {
      try {
        const response = await fetch(
          `https://4sx2gdf0k6.execute-api.ap-southeast-3.amazonaws.com/xcp/customer/find-by-id?customerId=${customerId}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              authorization: "Basic eGNwOk50dGkyMDI0IQ==",
            },
          }
        );

        const data = await response.json();
        if (!response.ok) {
          setError(data.message || "Failed to fetch customer data");
          throw new Error(data.message || "Failed to fetch customer data");
        }

        setCustomerDataDestination(data[0]); // Assuming data is an array with a single object
        setDestinationId(data[0].customer_id);
        setCompanyDestination(data[0].company_name);
        setPicDestination(data[0].pic_name);
        setEmailDestination(data[0].email);
      } catch (error) {
        console.error("Fetch Error:", error.message);
        setError("Fetch Error: " + error.message);
      }
    };
    if (customerId) {
      fetchCustomerById(customerId);
    }
  }, [customerId]);

  useEffect(() => {
    const fetchOrderTypes = async () => {
      try {
        const response = await fetch(
          "https://4sx2gdf0k6.execute-api.ap-southeast-3.amazonaws.com/xcp/master/order-type/find-all",
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              authorization: "Basic eGNwOk50dGkyMDI0IQ==",
            },
          }
        );

        const data = await response.json();

        if (!response.ok) {
          setError(data.body.message || "Failed to fetch order types");
          throw new Error(data.body.message || "Failed to fetch order types");
        } else {
          setOrderTypes(data.body);
        }
      } catch (error) {
        console.error("Fetch Error:", error.message);
        setError("Fetch Error: " + error.message);
      }
    };

    fetchOrderTypes();
  }, []);

  // const handleRadioChange = (event) => {
  //     if (event.target.id === 'connect-2') {
  //       setIsDisabled(true); // Enable input fields
  //     } else {
  //       setIsDisabled(false); // Disable input fields
  //     }
  // };

  useEffect(() => {
    const fetchOrderPriorities = async () => {
      try {
        const response = await fetch(
          "https://4sx2gdf0k6.execute-api.ap-southeast-3.amazonaws.com/xcp/master/order-priority/find-all",
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              authorization: "Basic eGNwOk50dGkyMDI0IQ==",
            },
          }
        );

        const data = await response.json();

        if (!response.ok) {
          setError("Failed to fetch order priorities");
          throw new Error("Failed to fetch order priorities");
        } else {
          setOrderPriorities(data.body);
        }
      } catch (error) {
        console.error("Fetch Error:", error.message);
        setError("Fetch Error: " + error.message);
      }
    };

    fetchOrderPriorities();
  }, []);

  useEffect(() => {
    // Function to fetch location data
    const fetchLocations = async () => {
      try {
        const response = await fetch(
          "https://4sx2gdf0k6.execute-api.ap-southeast-3.amazonaws.com/xcp/master/order-location/find-all",
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              authorization: "Basic eGNwOk50dGkyMDI0IQ==",
            },
          }
        );

        const data = await response.json();

        if (!response.ok) {
          setError("Failed to fetch locations");
          throw new Error("Failed to fetch locations");
        } else {
          setLocations(data.body);
        }
      } catch (error) {
        console.error("Fetch Error fetch locations:", error.message);
        setError("Fetch Error fetch locations: " + error.message);
      }
    };

    fetchLocations();
  }, []);

  const handleLocationChange = (event) => {
    let selectedLocation = event.target.value;
    selectedLocation = parseInt(selectedLocation, 10);
    setSelectedLocation(selectedLocation);

    fetchFloors(selectedLocation);
  };

  const handlePicDestinationChange = (event) => {
    let selectedPic = event.target.value;
    setSelectedPicDestination(selectedPic);
    fetchCustomerById(selectedPic);
  };

  const handleFloorChange = (event, source) => {
    try {
      let selectedFloorId = null;
      // Check if input is an event object or a number
      if (typeof event === "object" && event !== null && event.target) {
        // It's an event object
        selectedFloorId = parseInt(event.target.value, 10);
      } else if (typeof event === "number") {
        // It's a number
        selectedFloorId = event;
      }

      const selectedFloor = floors.find(
        (floor) => floor.xcp_floor_id === selectedFloorId
      );

      if (!selectedFloor) {
        setError("Selected floor not found");
        return;
      }

      if (source === AEnd1) {
        setAEndInfo({
          ...aEndInfo,
          floor: selectedFloorId,
        });
      } else if (source === BEnd1) {
        setBEndInfo({
          ...bEndInfo,
          floor: selectedFloorId,
        });
      } else if (source === AEnd2) {
        setAEndInfo2({
          ...aEndInfo2,
          floor: selectedFloorId,
        });
      } else if (source === BEnd2) {
        setBEndInfo2({
          ...bEndInfo2,
          floor: selectedFloorId,
        });
      } else if (source === AEnd3) {
        setAEndInfo3({
          ...aEndInfo3,
          floor: selectedFloorId,
        });
      } else if (source === BEnd3) {
        setBEndInfo3({
          ...bEndInfo3,
          floor: selectedFloorId,
        });
      } else if (source === AEnd4) {
        setAEndInfo4({
          ...aEndInfo4,
          floor: selectedFloorId,
        });
      } else if (source === BEnd4) {
        setBEndInfo4({
          ...bEndInfo4,
          floor: selectedFloorId,
        });
      } else if (source === AEnd5) {
        setAEndInfo5({
          ...aEndInfo5,
          floor: selectedFloorId,
        });
      } else if (source === BEnd5) {
        setBEndInfo5({
          ...bEndInfo5,
          floor: selectedFloorId,
        });
      }

      if (selectedFloor.xcp_location_floor_mapping_id === undefined) {
        setError("Floor mapping ID is undefined");
      } else {
        fetchRoomsMapping(selectedFloor.xcp_location_floor_mapping_id, source);
      }
    } catch (error) {
      setError(error);
      throw new Error(error);
    }
  };

  const fetchCustomerById = async (selectedPic) => {
    try {
      const response = await fetch(
        `https://4sx2gdf0k6.execute-api.ap-southeast-3.amazonaws.com/xcp/customer/find-by-id?customerId=${selectedPic}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            authorization: "Basic eGNwOk50dGkyMDI0IQ==",
          },
        }
      );

      const data = await response.json();
      // const statusCode = data.statusCode;
      if (!response.ok) {
        setError("Failed to fetch customer");
        throw new Error("Failed to fetch customer");
      } else {
        setDestinationId(data[0].customer_id);
        setPicDestination(data[0].pic_name);
        setEmailDestination(data[0].email);
        setError("");
      }
    } catch (error) {
      console.error("Fetch Error customer:", error.message);
      setError(
        "This company does not have an assigned Person in Charge (PIC)."
      );
    }
  };

  const fetchFloors = async (locationid) => {
    try {
      const response = await fetch(
        `https://4sx2gdf0k6.execute-api.ap-southeast-3.amazonaws.com/xcp/master/floor/find-by-location?orderLocation=${locationid}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            authorization: "Basic eGNwOk50dGkyMDI0IQ==",
          },
        }
      );

      const data = await response.json();
      if (!response.ok) {
        setError("Failed to fetch floors");
        throw new Error("Failed to fetch floors");
      } else {
        setFloors(data);
        setError("");
      }
    } catch (error) {
      console.error("Fetch Error floors:", error.message);
      setError("Fetch Error floors: " + error.message);
    }
  };

  const fetchRoomsMapping = async (
    xcp_location_floor_mapping_id,
    source,
    retries = 3
  ) => {
    try {
      const response = await fetch(
        `https://4sx2gdf0k6.execute-api.ap-southeast-3.amazonaws.com/xcp/master/room/find-by-floor?floorLocation=${xcp_location_floor_mapping_id}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            authorization: "Basic eGNwOk50dGkyMDI0IQ==",
          },
        }
      );

      const data = await response.json();
      if (!response.ok) {
        setError("Failed to fetch rooms");
        throw new Error("Failed to fetch rooms");
      }

      if (source === AEnd1) {
        setRoomsAend1(data);
      } else if (source === BEnd1) {
        setRoomsBend1(data);
      } else if (source === AEnd2) {
        setRoomsAend2(data);
      } else if (source === BEnd2) {
        setRoomsBend2(data);
      } else if (source === AEnd3) {
        setRoomsAend3(data);
      } else if (source === BEnd3) {
        setRoomsBend3(data);
      } else if (source === AEnd4) {
        setRoomsAend4(data);
      } else if (source === BEnd4) {
        setRoomsBend4(data);
      } else if (source === AEnd5) {
        setRoomsAend5(data);
      } else if (source === BEnd5) {
        setRoomsBend5(data);
      }
      setError("");
    } catch (error) {
      console.error("Fetch Error rooms:", error.message);
      setError("Fetch Error rooms: " + error.message);
      if (retries > 0) {
        await new Promise((resolve) => setTimeout(resolve, 500)); // wait for 0.5 second before retrying
        return fetchRoomsMapping(
          xcp_location_floor_mapping_id,
          source,
          retries - 1
        );
      }
    }
  };

  useEffect(() => {
    // Function to fetch cable type data
    const fetchCableTypes = async () => {
      try {
        const response = await fetch(
          "https://4sx2gdf0k6.execute-api.ap-southeast-3.amazonaws.com/xcp/master/cable-type/find-all",
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              authorization: "Basic eGNwOk50dGkyMDI0IQ==",
            },
          }
        );

        const data = await response.json();

        if (!response.ok) {
          setError("Failed to fetch cable types");
          throw new Error("Failed to fetch cable types");
        } else {
          if (data.body && Array.isArray(data.body)) {
            setCableTypes(data.body || []);
            setError("");
            return true; // Indicates success
          } else {
            throw new Error("Invalid data format");
          }
        }
      } catch (error) {
        console.error("Fetch Error cable types:", error.message);
        setError("Fetch Error cable types: " + error.message);
      }
    };

    fetchCableTypes();
  }, []);

  useEffect(() => {
    // Function to fetch interface data
    const fetchInterfaceData = async () => {
      try {
        const response = await fetch(
          "https://4sx2gdf0k6.execute-api.ap-southeast-3.amazonaws.com/xcp/master/interface/find-all",
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              authorization: "Basic eGNwOk50dGkyMDI0IQ==",
            },
          }
        );

        const data = await response.json();

        if (!response.ok) {
          setError("Failed to fetch interface data");
          throw new Error("Failed to fetch interface data");
        } else {
          if (data.body && Array.isArray(data.body)) {
            setInterfaceData(data.body || []);
            setError("");
            return true; // Indicates success
          } else {
            throw new Error("Invalid data format");
          }
        }
      } catch (error) {
        console.error("Fetch Error interface:", error.message);
        setError("Fetch Error interface: " + error.message);
        return false;
      }
    };

    fetchInterfaceData();
  }, []);

  const handleOrderTypeChange = (event, orderTypeId) => {
    // handleRadioChange(event);
    setSelectedOrderTypeId(orderTypeId);
    if (orderTypeId === 2) {
      setIsDestinationInformationOtherCompany(false);
      setCustomerId(requestorCustomerId);
      setCompanyCodeValue("");
      setCompanyCodeValuePlaceholder("");
      setErrorCompanyCode("");
      setIsDisabledCompanyCode(true);
      setIsRequiredCompanyCode(false);

      setCustomerDataDestination(customerData);
      setDestinationId(customerData.customer_id);
      setCompanyDestination(customerData.company_name);
      setPicDestination(customerData.pic_name);
      setEmailDestination(customerData.email);
    } else {
      setIsDisabledCompanyCode(false);
      setIsRequiredCompanyCode(true);
      setCustomerDataDestination("");
      setEmailDestination("");
      setIsDestinationInformationOtherCompany(true);
    }
  };

  useEffect(() => {
    // Set the current date for the order date field
    const currentDate = new Date().toISOString().split("T")[0];
    setOrderDate(currentDate);
  }, []);

  const handleClose = () => {
    setOpenConfirm(false);
    setOpenFail(false);
  };

  const handleConfirmation = async (event) => {
    event.preventDefault();
    if (selectedOrderTypeId == 1) {
      const isValid = validateUploadApprovalLetter();
      if (isValid == true) {
        setOpenConfirm(true);
      }
    } else if (selectedOrderTypeId == 2) {
      setOpenConfirm(true);
    }
  };

  const isUploadApprovalLetterHidden = () => selectedOrderTypeId === 2;

  async function uploadApprovalLetter(orderId) {
    setUploading(true);

    try {
      // Step 1: Get the presigned URL from the backend
      const response = await axios.get(
        `https://4sx2gdf0k6.execute-api.ap-southeast-3.amazonaws.com/xcp/order/upload-approval-letter?orderId=${orderId}&fileName=${file.name}`,
        {
          headers: {
            authorization: "Basic eGNwOk50dGkyMDI0IQ==",
          },
        }
      );

      if (response.status === 200) {
        const uploadUrl = response.data.uploadUrl;

        // Step 2: Upload the file to S3 using the presigned URL
        const responseUploadS3 = await axios.put(uploadUrl, file, {
          headers: {
            "Content-Type": file.type,
          },
        });

        if (responseUploadS3.status === 200) {
          setOpenConfirm(false);
          setOpenSuccess(true);
        } else {
          setOpenConfirm(false);
          setOpenFail(true);
        }
      } else {
        setError("File upload failed: " + response.message);
      }
    } catch (err) {
      setError("File upload failed");
      console.error("File upload failed", err);
    } finally {
      setUploading(false);
    }
  }

  function isValidFileName(fileName) {
    // Regular expression to match special characters (excluding spaces and alphanumeric characters)
    const regex = /^[a-zA-Z0-9 ._-]+$/;
    return regex.test(fileName);
  }

  function validateUploadApprovalLetter() {
    let isValid = true;
    if (!file) {
      setOpenConfirm(false);
      setErrorUpload("Please upload one a valid file");
      window.scrollTo(0, 0);
      isValid = false;
    }

    if (file && !isValidFileName(file.name)) {
      setOpenConfirm(false);
      // Handle invalid file name
      setErrorUpload(
        "File name contains special characters. Please use only letters or numbers"
      );
      window.scrollTo(0, 0);
      isValid = false;
    }
    return isValid;
  }

  //upload letter
  const [uploading, setUploading] = useState(false);
  const [file, setFile] = useState(null);

  // const fileTypes = ["application/pdf", "application/docx", "application/doc", "application/png", "application/jpg", "application/msg"];
  const fileTypes = [
    "application/pdf", // .pdf
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // .docx
    "application/msword", // .doc
    "image/png", // .png
    "image/jpeg", // .jpg/.jpeg
    "application/vnd.ms-outlook", // .msg (Note: MIME type ini tidak selalu tersedia tergantung browser/OS)
  ];
  const maxSize = 10 * 1024 * 1024; // 10MB

  const onDrop = useCallback((acceptedFiles) => {
    const selectedFile = acceptedFiles[0];
    setError(null); // Clear previous error

    // Validate file type
    if (!fileTypes.includes(selectedFile.type)) {
      setErrorUpload(
        "Invalid file type, allowed file types .pdf, .docx; .msg; .png; .jpg"
      );
      setFile(null);
      return;
    }

    // Validate file size
    if (selectedFile.size > maxSize) {
      setErrorUpload(
        "File size exceeds 10MB, please upload file size below 10MB"
      );
      return;
    }

    if (!selectedFile) {
      setErrorUpload("No file selected");
      return;
    }

    setFile(selectedFile);
    setErrorUpload("");
  }, []);

  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
    accept: fileTypes.join(","),
    multiple: false,
  });

  function inputSuccess() {
    navigate("/order-list");
  }

  const handleSubmit = async (event) => {
    setIsLoading(true);
    const selectedDate = orderDate;
    const userTimeZone = moment.tz.guess();
    // Get the current time in the user's local time zone
    const currentTime = moment.tz(userTimeZone).format("HH:mm:ss");
    // Combine the selected date with the current time
    const dateTimeInUserTimeZone = moment
      .tz(`${selectedDate}T${currentTime}`, userTimeZone)
      .format("YYYY-MM-DDTHH:mm:ss");

    const destinationFields = {
      destinationId,
      companyDestination,
      picDestination,
      emailDestination,
    };

    if (Object.values(destinationFields).some((value) => !value)) {
      setError("Please fill the destination data.");
      window.scrollTo(0, 0);
      setIsLoading(false);
      setOpenConfirm(false);
      return;
    }

    const inputOrder = {
      order_type: selectedOrderTypeId,
      order_priority: orderPriority,
      requestor_id: requestorId,
      company_requestor: companyRequestor,
      pic_requestor: picRequestor,
      email_requestor: emailRequestor,
      destination_id: destinationId,
      company_destination: companyDestination,
      pic_destination: picDestination,
      email_destination: emailDestination,
      order_date: dateTimeInUserTimeZone,
      location_server: selectedLocation,
      orderItemlist: [],
    };

    const orderItem1 = {
      a_end_cable_type: aEndInfo.cableType,
      b_end_cable_type: bEndInfo.cableType,
      a_end_interface: aEndInfo.interface,
      b_end_interface: bEndInfo.interface,
      a_end_floor: aEndInfo.floor,
      b_end_floor: bEndInfo.floor,
      a_end_room: aEndInfo.room,
      b_end_room: bEndInfo.room,
      a_end_rack_id: aEndInfo.rackId,
      b_end_rack_id: bEndInfo.rackId,
      cable_quantity: aEndInfo.cableQuantity,
    };

    const orderItem2 = {
      a_end_cable_type: aEndInfo2.cableType,
      b_end_cable_type: bEndInfo2.cableType,
      a_end_interface: aEndInfo2.interface,
      b_end_interface: bEndInfo2.interface,
      a_end_floor: aEndInfo2.floor,
      b_end_floor: bEndInfo2.floor,
      a_end_room: aEndInfo2.room,
      b_end_room: bEndInfo2.room,
      a_end_rack_id: aEndInfo2.rackId,
      b_end_rack_id: bEndInfo2.rackId,
      cable_quantity: aEndInfo2.cableQuantity,
    };

    const orderItem3 = {
      a_end_cable_type: aEndInfo3.cableType,
      b_end_cable_type: bEndInfo3.cableType,
      a_end_interface: aEndInfo3.interface,
      b_end_interface: bEndInfo3.interface,
      a_end_floor: aEndInfo3.floor,
      b_end_floor: bEndInfo3.floor,
      a_end_room: aEndInfo3.room,
      b_end_room: bEndInfo3.room,
      a_end_rack_id: aEndInfo3.rackId,
      b_end_rack_id: bEndInfo3.rackId,
      cable_quantity: aEndInfo3.cableQuantity,
    };

    const orderItem4 = {
      a_end_cable_type: aEndInfo4.cableType,
      b_end_cable_type: bEndInfo4.cableType,
      a_end_interface: aEndInfo4.interface,
      b_end_interface: bEndInfo4.interface,
      a_end_floor: aEndInfo4.floor,
      b_end_floor: bEndInfo4.floor,
      a_end_room: aEndInfo4.room,
      b_end_room: bEndInfo4.room,
      a_end_rack_id: aEndInfo4.rackId,
      b_end_rack_id: bEndInfo4.rackId,
      cable_quantity: aEndInfo4.cableQuantity,
    };

    const orderItem5 = {
      a_end_cable_type: aEndInfo5.cableType,
      b_end_cable_type: bEndInfo5.cableType,
      a_end_interface: aEndInfo5.interface,
      b_end_interface: bEndInfo5.interface,
      a_end_floor: aEndInfo5.floor,
      b_end_floor: bEndInfo5.floor,
      a_end_room: aEndInfo5.room,
      b_end_room: bEndInfo5.room,
      a_end_rack_id: aEndInfo5.rackId,
      b_end_rack_id: bEndInfo5.rackId,
      cable_quantity: aEndInfo5.cableQuantity,
    };

    if (xcpCount >= 1) {
      inputOrder.orderItemlist.push(orderItem1);
    }

    if (xcpCount >= 2) {
      inputOrder.orderItemlist.push(orderItem2);
    }

    if (xcpCount >= 3) {
      inputOrder.orderItemlist.push(orderItem3);
    }

    if (xcpCount >= 4) {
      inputOrder.orderItemlist.push(orderItem4);
    }
    if (xcpCount >= 5) {
      inputOrder.orderItemlist.push(orderItem5);
    }

    try {
      const response = await fetch(
        "https://4sx2gdf0k6.execute-api.ap-southeast-3.amazonaws.com/xcp/order/input-order",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            authorization: "Basic eGNwOk50dGkyMDI0IQ==",
          },
          body: JSON.stringify(inputOrder),
        }
      );

      const data = await response.json();
      const responseBody = JSON.parse(data.body);

      if (!response.ok) {
        throw new Error("Failed to submit order");
      }

      const { message, xcp_order_id } = responseBody;
      setIsLoading(false);

      if (message == "success") {
        setOpenConfirm(false);
        await uploadApprovalLetter(xcp_order_id);
        setOpenSuccess(true);
      } else {
        setOpenConfirm(false);
        setOpenFail(true);
      }
    } catch (error) {
      setError("Submission Error: " + error.message);
      console.error("Submission Error:", error.message);
      setOpenConfirm(false);
      setOpenFail(true);
    }
  };

  const addNewCrossConnect = () => {
    // When displaying the orderDate

    if (xcpCount >= 1) {
      setShowBtnRemove(true);
    }

    if (xcpCount == 1) {
      setShowXcp2(true);
      setXcpCount(2);
    } else if (xcpCount == 2) {
      setShowXcp3(true);
      setXcpCount(3);
    } else if (xcpCount == 3) {
      setShowXcp4(true);
      setXcpCount(4);
    } else if (xcpCount == 4) {
      setShowXcp5(true);
      setXcpCount(5);
    }
  };

  const removeCrossConnect = () => {
    if (xcpCount == 2) {
      setShowXcp2(false);
      setXcpCount(1);
    }

    if (xcpCount == 3) {
      setShowXcp3(false);
      setXcpCount(2);
    }

    if (xcpCount == 4) {
      setShowXcp4(false);
      setXcpCount(3);
    }

    if (xcpCount == 5) {
      setShowXcp5(false);
      setXcpCount(4);
    }
  };

  useEffect(() => {
    if (xcpCount == 5) {
      setShowBtnAdd(false);
    } else {
      setShowBtnAdd(true);
    }

    if (xcpCount == 1) {
      setShowBtnRemove(false);
    }
  }, [xcpCount]);

  useEffect(() => {
    token = localStorage.getItem("token");
  }, [token]);

  const handleCompanyCodeChange = (e) => {
    const companyCodeInserted = e.target.value;
    if (companyCodeInserted.length <= 8) {
      setCompanyCodeValue(companyCodeInserted);
      setCompanyCodeValuePlaceholder(companyCodeInserted);
      if (companyCodeInserted.length === 8) {
        setEmailDestination("");
        if (companyCodeInserted === customerData.company_code) {
          setError("");
          setCustomerDataDestination([]);
          setErrorCompanyCode(
            "Please use other company code instead of your own company code."
          );
        } else {
          fetchCustomerDataDestination(companyCodeInserted);
        }
      }
    }
  };

  const fetchCustomerDataDestination = async (companyCode) => {
    try {
      const response = await fetch(
        `https://4sx2gdf0k6.execute-api.ap-southeast-3.amazonaws.com/xcp/company/find-by-code?companyCode=${companyCode}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            authorization: "Basic eGNwOk50dGkyMDI0IQ==",
          },
        }
      );

      const data = await response.json();
      if (!response.ok) {
        setError(data.message || "Failed to fetch Company data destination");
        throw new Error(
          data.message || "Failed to fetch Company data destination"
        );
      }

      if (Array.isArray(data) && data.length === 0) {
        setErrorCompanyCode("Company code not found");
        setCustomerDataDestination([]);
      } else {
        setErrorCompanyCode("");

        setCustomerDataDestination(data);
        setCompanyDestination(data[0].company_name);
        setError("");
      }
    } catch (error) {
      console.error("Fetch Error Company data destination:", error.message);
      setError("Fetch Error Company data destination: " + error.message);
    }
  };

  return (
    <div className="container-order-input">
      {isLoading && <LoadingScreen />}
      <Dialog open={openConfirm}>
        <DialogTitle>
          {"Are you sure you want to submit this order?"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            Clicking "Yes" will submit this order.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            No
          </Button>
          <Button onClick={handleSubmit} color="primary" autoFocus>
            Yes
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog open={openSuccess}>
        <DialogTitle>{"Order Form submitted successfully"}</DialogTitle>
        <DialogActions>
          <Button onClick={inputSuccess} color="primary" autoFocus>
            Ok
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog open={openFail}>
        <DialogTitle>{"Order Form submitted Failed"}</DialogTitle>
        <DialogActions>
          <Button onClick={handleClose} color="primary" autoFocus>
            Ok
          </Button>
        </DialogActions>
      </Dialog>
      <input type="hidden" name="token" value={token} />{" "}
      {/* Hidden token field */}
      <h1>Cross Connect Input Order Form</h1>
      <h6>Fulfill the order form as follows.</h6>
      {error && <p className="error-message">{error}</p>}
      <div className="title-order-input">
        <h5>Order Information</h5>
      </div>
      <form onSubmit={handleConfirmation}>
        <div className="box-two-part">
          <div className="up-left-order">
            <div className="radio-button">
              <label>Cross Connect Type</label>
              {orderTypes.map((orderType) => (
                <div key={orderType.xcp_order_type_id}>
                  <input
                    type="radio"
                    name="connect"
                    id={`connect-${orderType.xcp_order_type_id}`}
                    onChange={(event) =>
                      handleOrderTypeChange(event, orderType.xcp_order_type_id)
                    }
                    checked={
                      selectedOrderTypeId === orderType.xcp_order_type_id
                    }
                  />
                  <label htmlFor={`connect-${orderType.xcp_order_type_id}`}>
                    {orderType.xcp_order_type_name}
                  </label>
                </div>
              ))}
            </div>
            <div className="textbox">
              <label htmlFor="companyCode">Company Code</label>
              <input
                type="text"
                placeholder={companyCodeValuePlaceholder}
                value={companyCodeValue}
                onChange={handleCompanyCodeChange}
                minLength={8}
                maxLength={8}
                disabled={isDisabledCompanyCode}
                required={isRequiredCompanyCode}
              />
              {errorCompanyCode && (
                <p className="error-message">{errorCompanyCode}</p>
              )}
            </div>
            <label></label>
            <div className="radio-button" style={{ display: "none" }}>
              <label className="order-priority">Order Priority</label>
              {orderPriorities.map((priority) => (
                <div key={priority.xcp_order_priority_id}>
                  <input
                    type="radio"
                    name="orderPriority"
                    id={`order-priority-${priority.xcp_order_priority_id}`}
                    // defaultChecked={priority.xcp_order_priority_id === 1}
                    onChange={() =>
                      setOrderPriority(priority.xcp_order_priority_id)
                    }
                    checked={orderPriority === priority.xcp_order_priority_id}
                    disabled
                  />
                  <label
                    htmlFor={`order-priority-${priority.xcp_order_priority_id}`}
                  >
                    {priority.xcp_order_priority_name}
                  </label>
                </div>
              ))}
            </div>
          </div>

          <div
            className="up-right-order"
            hidden={isUploadApprovalLetterHidden()}
          >
            <label className="uploadApprovalLetterLable">
              Upload Approval Evidence
            </label>
            <div {...getRootProps()} className="dropzone-order">
              <input {...getInputProps()} />
              <FaCloudUploadAlt size={50} color="#007bff" />
              <p>
                Drag and drop the file (max 10MB) here, or click to select one
              </p>
            </div>
            {file && (
              <div className="file-info-order">
                <p>File Name: </p>
                <p className="file-name">{file.name}</p>
              </div>
            )}
            {errorUpload && <p className="error-message">{errorUpload}</p>}
          </div>
        </div>

        <div className="box-two-part">
          <div className="requestor-information">
            <div className="title-box-order-input">
              <h5>Requestor Information (A-End)</h5>
            </div>
            <div className="textbox-gray">
              <label htmlFor="companyName">Company Name</label>
              <input
                type="text"
                placeholder="Company Name"
                value={customerData ? customerData.company_name : ""}
                onChange={(e) => setCompanyRequestor(e.target.value)}
                required
                disabled
              />
            </div>
            <div className="textbox-gray">
              <label htmlFor="picName">PIC Name</label>
              <input
                type="text"
                placeholder="PIC Name"
                value={customerData ? customerData.pic_name : ""}
                onChange={(customerData) =>
                  setPicRequestor(customerData.pic_name)
                }
                required
                disabled
              />
            </div>
            <div className="textbox-gray">
              <label htmlFor="contactEmail">Contact e-mail</label>
              <input
                type="text"
                placeholder="xxx@xxx.com"
                value={customerData ? customerData.email : ""}
                onChange={(e) => setEmailRequestor(e.target.value)}
                required
                disabled
              />
            </div>
            <div className="textbox">
              <label htmlFor="orderDate">Order Date</label>
              <input
                type="date"
                id="orderDate"
                value={orderDate}
                onChange={(e) => setOrderDate(e.target.value)}
                required
                disabled
              />
            </div>
            <div className="textbox">
              <label htmlFor="comboBox" className="requestLocation">
                Request Location
              </label>
              <select
                id="comboBox"
                name="options"
                value={selectedLocation}
                onChange={handleLocationChange}
                required
              >
                <option value="">Select Location</option>
                {locations.map((location) => (
                  <option
                    key={location.xcp_order_location_id}
                    value={location.xcp_order_location_id}
                  >
                    {location.xcp_order_location_name}
                  </option>
                ))}
              </select>
            </div>
          </div>

          {/* Kondisi untuk menampilkan atau menyembunyikan div */}
          {isDestinationInformationOtherCompany ? (
            <div className="destination-information-other-company">
              <div className="title-box-order-input">
                <h5>Destination Information (B-End)</h5>
              </div>
              <div className="textbox-gray">
                <label htmlFor="companyName">Company Name</label>
                <input
                  type="text"
                  value={
                    customerDataDestination[0]
                      ? customerDataDestination[0].company_name
                      : ""
                  }
                  onChange={(e) => setCompanyDestination(e.target.value)}
                  required
                  disabled
                />
              </div>
              <div className="textbox">
                <label htmlFor="comboBox" className="picName">
                  PIC Name
                </label>
                <select
                  id="comboBox"
                  name="options"
                  value={selectedPicDestination}
                  onChange={handlePicDestinationChange}
                  required
                >
                  <option value="">Select PIC</option>
                  {customerDataDestination
                    ? customerDataDestination.map((pic) => (
                        <option key={pic.customer_id} value={pic.customer_id}>
                          {pic.pic_name}
                        </option>
                      ))
                    : []}
                </select>
              </div>
              <div className="textbox-gray">
                <label htmlFor="contactEmail">Contact e-mail</label>
                <input
                  type="text"
                  value={emailDestination ? emailDestination : ""}
                  required
                  onChange={(e) => setEmailDestination(e.target.value)}
                  disabled
                />
              </div>
            </div>
          ) : (
            <div className="destination-information">
              <div className="title-box-order-input">
                <h5>Destination Information (B-End)</h5>
              </div>
              <div className="textbox-gray">
                <label htmlFor="companyName">Company Name</label>
                <input
                  type="text"
                  value={
                    customerDataDestination
                      ? customerDataDestination.company_name
                      : ""
                  }
                  onChange={(e) => setCompanyDestination(e.target.value)}
                  required
                  disabled
                />
              </div>
              <div className="textbox-gray">
                <label htmlFor="picName">PIC Name</label>
                <input
                  type="text"
                  value={
                    customerDataDestination
                      ? customerDataDestination.pic_name
                      : ""
                  }
                  onChange={(e) => setPicDestination(e.target.value)}
                  required
                  disabled
                />
              </div>
              <div className="textbox-gray">
                <label htmlFor="contactEmail">Contact e-mail</label>
                <input
                  type="text"
                  value={
                    customerDataDestination ? customerDataDestination.email : ""
                  }
                  required
                  onChange={(e) => setEmailDestination(e.target.value)}
                  disabled
                />
              </div>
            </div>
          )}
        </div>

        {/*one*/}
        <div className="box-two-part">
          <div className="a-end-information">
            <div className="title-box-order-input">
              <h5>A-end Information (1)</h5>
            </div>
            <div className="textbox">
              <label htmlFor="comboBox">Cable Type</label>
              <select
                id="comboBox"
                name="options"
                onChange={(e) =>
                  setAEndInfo({
                    ...aEndInfo,
                    cableType: parseInt(e.target.value, 10),
                  })
                }
                required
              >
                <option value="">Select Cable Type</option>
                {cableTypes.map((cableType) => (
                  <option
                    key={cableType.xcp_cable_type_id}
                    value={cableType.xcp_cable_type_id}
                  >
                    {cableType.xcp_cable_type_name}
                  </option>
                ))}
              </select>
            </div>
            <div className="textbox">
              <label htmlFor="comboBox">Interface</label>
              <select
                id="comboBox"
                name="options"
                onChange={(e) =>
                  setAEndInfo({
                    ...aEndInfo,
                    interface: parseInt(e.target.value, 10),
                  })
                }
                required
              >
                <option value="">Select Interface</option>
                {interfaceData.map((interfacedata) => (
                  <option
                    key={interfacedata.xcp_order_location_id}
                    value={interfacedata.xcp_interface_id}
                  >
                    {interfacedata.xcp_interface_name}
                  </option>
                ))}
              </select>
            </div>
            <div className="textbox">
              <label htmlFor="comboBox">Floor</label>
              <select
                id="comboBox"
                name="options"
                onChange={(e) => handleFloorChange(e, AEnd1)}
                required
              >
                <option value="">Select Floor</option>
                {floors.map((floor) => (
                  <option key={floor.xcp_floor_id} value={floor.xcp_floor_id}>
                    {floor.xcp_floor_name}
                  </option>
                ))}
              </select>
            </div>
            <div className="textbox">
              <label htmlFor="comboBox">Room</label>
              <select
                id="comboBox"
                name="options"
                onChange={(e) =>
                  setAEndInfo({
                    ...aEndInfo,
                    room: parseInt(e.target.value, 10),
                  })
                }
                required
              >
                <option value="">Select Room</option>
                {roomsAend1.map((room) => (
                  <option key={room.xcp_room_id} value={room.xcp_room_id}>
                    {room.xcp_room_name}
                  </option>
                ))}
              </select>
            </div>
            <div className="textbox">
              <label htmlFor="rackId">Rack ID</label>
              <input
                type="text"
                placeholder="L1.MMR01.04-01"
                onChange={(e) =>
                  setAEndInfo({ ...aEndInfo, rackId: e.target.value })
                }
                required
              />
            </div>
            <div className="textbox">
              <label htmlFor="cableQuantity">Cable Quantity</label>
              <input
                type="number"
                min="1"
                max="20"
                placeholder="2"
                onChange={(e) => {
                  const value = parseInt(e.target.value, 10);
                  if (value >= 1 && value <= 20) {
                    setAEndInfo({
                      ...aEndInfo,
                      cableQuantity: value,
                    });
                  } else {
                    e.target.value = ""; // Clear the input if the value is out of range
                  }
                }}
                required
              />
            </div>
          </div>

          <div className="b-end-information">
            <div className="title-box-order-input">
              <h5>B-end Information (1)</h5>
            </div>
            <div className="textbox">
              <label htmlFor="comboBox">Cable Type</label>
              <select
                id="comboBox"
                name="options"
                onChange={(e) =>
                  setBEndInfo({
                    ...bEndInfo,
                    cableType: parseInt(e.target.value, 10),
                  })
                }
                required
              >
                <option value="">Select Cable Type</option>
                {cableTypes.map((cableType) => (
                  <option
                    key={cableType.xcp_cable_type_id}
                    value={cableType.xcp_cable_type_id}
                  >
                    {cableType.xcp_cable_type_name}
                  </option>
                ))}
              </select>
            </div>
            <div className="textbox">
              <label htmlFor="comboBox">Interface</label>
              <select
                id="comboBox"
                name="options"
                onChange={(e) =>
                  setBEndInfo({
                    ...bEndInfo,
                    interface: parseInt(e.target.value, 10),
                  })
                }
                required
              >
                <option value="">Select Interface</option>
                {interfaceData.map((interfacedata) => (
                  <option
                    key={interfacedata.xcp_order_location_id}
                    value={interfacedata.xcp_interface_id}
                  >
                    {interfacedata.xcp_interface_name}
                  </option>
                ))}
              </select>
            </div>
            <div className="textbox">
              <label htmlFor="comboBox">Floor</label>
              <select
                id="comboBox"
                name="options"
                onChange={(e) => handleFloorChange(e, BEnd1)}
                required
              >
                <option value="">Select Floor</option>
                {floors.map((floor) => (
                  <option key={floor.xcp_floor_id} value={floor.xcp_floor_id}>
                    {floor.xcp_floor_name}
                  </option>
                ))}
              </select>
            </div>
            <div className="textbox">
              <label htmlFor="comboBox">Room</label>
              <select
                id="comboBox"
                name="options"
                onChange={(e) =>
                  setBEndInfo({
                    ...bEndInfo,
                    room: parseInt(e.target.value, 10),
                  })
                }
                required
              >
                <option value="">Select Room</option>
                {roomsBend1.map((room) => (
                  <option key={room.xcp_room_id} value={room.xcp_room_id}>
                    {room.xcp_room_name}
                  </option>
                ))}
              </select>
            </div>
            <div className="textbox">
              <label htmlFor="rackId">Rack ID</label>
              <input
                type="text"
                placeholder="L1.MMR01.04-01"
                onChange={(e) =>
                  setBEndInfo({ ...bEndInfo, rackId: e.target.value })
                }
                required
              />
            </div>
          </div>
        </div>

        {/*two*/}
        {showXcp2 && (
          <div className="xcp2">
            <div className="box-two-part">
              <div className="a-end-information">
                <div className="title-box-order-input">
                  <h5>A-end Information (2)</h5>
                </div>
                <div className="textbox">
                  <label htmlFor="comboBox">Cable Type</label>
                  <select
                    id="comboBox"
                    name="options"
                    onChange={(e) =>
                      setAEndInfo2({
                        ...aEndInfo2,
                        cableType: parseInt(e.target.value, 10),
                      })
                    }
                    required
                  >
                    <option value="">Select Cable Type</option>
                    {cableTypes.map((cableType) => (
                      <option
                        key={cableType.xcp_cable_type_id}
                        value={cableType.xcp_cable_type_id}
                      >
                        {cableType.xcp_cable_type_name}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="textbox">
                  <label htmlFor="comboBox">Interface</label>
                  <select
                    id="comboBox"
                    name="options"
                    onChange={(e) =>
                      setAEndInfo2({
                        ...aEndInfo2,
                        interface: parseInt(e.target.value, 10),
                      })
                    }
                    required
                  >
                    <option value="">Select Interface</option>
                    {interfaceData.map((interfacedata) => (
                      <option
                        key={interfacedata.xcp_order_location_id}
                        value={interfacedata.xcp_interface_id}
                      >
                        {interfacedata.xcp_interface_name}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="textbox">
                  <label htmlFor="comboBox">Floor</label>
                  <select
                    id="comboBox"
                    name="options"
                    onChange={(e) => handleFloorChange(e, AEnd2)}
                    required
                  >
                    <option value="">Select Floor</option>
                    {floors.map((floor) => (
                      <option
                        key={floor.xcp_floor_id}
                        value={floor.xcp_floor_id}
                      >
                        {floor.xcp_floor_name}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="textbox">
                  <label htmlFor="comboBox">Room</label>
                  <select
                    id="comboBox"
                    name="options"
                    onChange={(e) =>
                      setAEndInfo2({
                        ...aEndInfo2,
                        room: parseInt(e.target.value, 10),
                      })
                    }
                    required
                  >
                    <option value="">Select Room</option>
                    {roomsAend2.map((room) => (
                      <option key={room.xcp_room_id} value={room.xcp_room_id}>
                        {room.xcp_room_name}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="textbox">
                  <label htmlFor="rackId">Rack ID</label>
                  <input
                    type="text"
                    placeholder="L1.MMR01.04-01"
                    onChange={(e) =>
                      setAEndInfo2({ ...aEndInfo2, rackId: e.target.value })
                    }
                    required
                  />
                </div>
                <div className="textbox">
                  <label htmlFor="cableQuantity">Cable Quantity</label>
                  <input
                    type="number"
                    min="1"
                    max="20"
                    placeholder="2"
                    onChange={(e) => {
                      const value = parseInt(e.target.value, 10);
                      if (value >= 1 && value <= 20) {
                        setAEndInfo2({
                          ...aEndInfo2,
                          cableQuantity: value,
                        });
                      } else {
                        e.target.value = ""; // Clear the input if the value is out of range
                      }
                    }}
                    required
                  />
                </div>
              </div>

              <div className="b-end-information">
                <div className="title-box-order-input">
                  <h5>B-end Information (2)</h5>
                </div>
                <div className="textbox">
                  <label htmlFor="comboBox">Cable Type</label>
                  <select
                    id="comboBox"
                    name="options"
                    onChange={(e) =>
                      setBEndInfo2({
                        ...bEndInfo2,
                        cableType: parseInt(e.target.value, 10),
                      })
                    }
                    required
                  >
                    <option value="">Select Cable Type</option>
                    {cableTypes.map((cableType) => (
                      <option
                        key={cableType.xcp_cable_type_id}
                        value={cableType.xcp_cable_type_id}
                      >
                        {cableType.xcp_cable_type_name}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="textbox">
                  <label htmlFor="comboBox">Interface</label>
                  <select
                    id="comboBox"
                    name="options"
                    onChange={(e) =>
                      setBEndInfo2({
                        ...bEndInfo2,
                        interface: parseInt(e.target.value, 10),
                      })
                    }
                    required
                  >
                    <option value="">Select Interface</option>
                    {interfaceData.map((interfacedata) => (
                      <option
                        key={interfacedata.xcp_order_location_id}
                        value={interfacedata.xcp_interface_id}
                      >
                        {interfacedata.xcp_interface_name}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="textbox">
                  <label htmlFor="comboBox">Floor</label>
                  <select
                    id="comboBox"
                    name="options"
                    onChange={(e) => handleFloorChange(e, BEnd2)}
                    required
                  >
                    <option value="">Select Floor</option>
                    {floors.map((floor) => (
                      <option
                        key={floor.xcp_floor_id}
                        value={floor.xcp_floor_id}
                      >
                        {floor.xcp_floor_name}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="textbox">
                  <label htmlFor="comboBox">Room</label>
                  <select
                    id="comboBox"
                    name="options"
                    onChange={(e) =>
                      setBEndInfo2({
                        ...bEndInfo2,
                        room: parseInt(e.target.value, 10),
                      })
                    }
                    required
                  >
                    <option value="">Select Room</option>
                    {roomsBend2.map((room) => (
                      <option key={room.xcp_room_id} value={room.xcp_room_id}>
                        {room.xcp_room_name}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="textbox">
                  <label htmlFor="rackId">Rack ID</label>
                  <input
                    type="text"
                    placeholder="L1.MMR01.04-01"
                    onChange={(e) =>
                      setBEndInfo2({ ...bEndInfo2, rackId: e.target.value })
                    }
                    required
                  />
                </div>
              </div>
            </div>
          </div>
        )}

        {/*three*/}
        {showXcp3 && (
          <div className="xcp3">
            <div className="box-two-part">
              <div className="a-end-information">
                <div className="title-box-order-input">
                  <h5>A-end Information (3)</h5>
                </div>
                <div className="textbox">
                  <label htmlFor="comboBox">Cable Type</label>
                  <select
                    id="comboBox"
                    name="options"
                    onChange={(e) =>
                      setAEndInfo3({
                        ...aEndInfo3,
                        cableType: parseInt(e.target.value, 10),
                      })
                    }
                    required
                  >
                    <option value="">Select Cable Type</option>
                    {cableTypes.map((cableType) => (
                      <option
                        key={cableType.xcp_cable_type_id}
                        value={cableType.xcp_cable_type_id}
                      >
                        {cableType.xcp_cable_type_name}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="textbox">
                  <label htmlFor="comboBox">Interface</label>
                  <select
                    id="comboBox"
                    name="options"
                    onChange={(e) =>
                      setAEndInfo3({
                        ...aEndInfo3,
                        interface: parseInt(e.target.value, 10),
                      })
                    }
                    required
                  >
                    <option value="">Select Interface</option>
                    {interfaceData.map((interfacedata) => (
                      <option
                        key={interfacedata.xcp_order_location_id}
                        value={interfacedata.xcp_interface_id}
                      >
                        {interfacedata.xcp_interface_name}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="textbox">
                  <label htmlFor="comboBox">Floor</label>
                  <select
                    id="comboBox"
                    name="options"
                    onChange={(e) => handleFloorChange(e, AEnd3)}
                    required
                  >
                    <option value="">Select Floor</option>
                    {floors.map((floor) => (
                      <option
                        key={floor.xcp_floor_id}
                        value={floor.xcp_floor_id}
                      >
                        {floor.xcp_floor_name}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="textbox">
                  <label htmlFor="comboBox">Room</label>
                  <select
                    id="comboBox"
                    name="options"
                    onChange={(e) =>
                      setAEndInfo3({
                        ...aEndInfo3,
                        room: parseInt(e.target.value, 10),
                      })
                    }
                    required
                  >
                    <option value="">Select Room</option>
                    {roomsAend3.map((room) => (
                      <option key={room.xcp_room_id} value={room.xcp_room_id}>
                        {room.xcp_room_name}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="textbox">
                  <label htmlFor="rackId">Rack ID</label>
                  <input
                    type="text"
                    placeholder="L1.MMR01.04-01"
                    onChange={(e) =>
                      setAEndInfo3({ ...aEndInfo3, rackId: e.target.value })
                    }
                    required
                  />
                </div>
                <div className="textbox">
                  <label htmlFor="cableQuantity">Cable Quantity</label>
                  <input
                    type="number"
                    min="1"
                    max="20"
                    placeholder="2"
                    onChange={(e) => {
                      const value = parseInt(e.target.value, 10);
                      if (value >= 1 && value <= 20) {
                        setAEndInfo3({
                          ...aEndInfo3,
                          cableQuantity: value,
                        });
                      } else {
                        e.target.value = ""; // Clear the input if the value is out of range
                      }
                    }}
                    required
                  />
                </div>
              </div>

              <div className="b-end-information">
                <div className="title-box-order-input">
                  <h5>B-end Information (3)</h5>
                </div>
                <div className="textbox">
                  <label htmlFor="comboBox">Cable Type</label>
                  <select
                    id="comboBox"
                    name="options"
                    onChange={(e) =>
                      setBEndInfo3({
                        ...bEndInfo3,
                        cableType: parseInt(e.target.value, 10),
                      })
                    }
                    required
                  >
                    <option value="">Select Cable Type</option>
                    {cableTypes.map((cableType) => (
                      <option
                        key={cableType.xcp_cable_type_id}
                        value={cableType.xcp_cable_type_id}
                      >
                        {cableType.xcp_cable_type_name}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="textbox">
                  <label htmlFor="comboBox">Interface</label>
                  <select
                    id="comboBox"
                    name="options"
                    onChange={(e) =>
                      setBEndInfo3({
                        ...bEndInfo3,
                        interface: parseInt(e.target.value, 10),
                      })
                    }
                    required
                  >
                    <option value="">Select Interface</option>
                    {interfaceData.map((interfacedata) => (
                      <option
                        key={interfacedata.xcp_order_location_id}
                        value={interfacedata.xcp_interface_id}
                      >
                        {interfacedata.xcp_interface_name}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="textbox">
                  <label htmlFor="comboBox">Floor</label>
                  <select
                    id="comboBox"
                    name="options"
                    onChange={(e) => handleFloorChange(e, BEnd3)}
                    required
                  >
                    <option value="">Select Floor</option>
                    {floors.map((floor) => (
                      <option
                        key={floor.xcp_floor_id}
                        value={floor.xcp_floor_id}
                      >
                        {floor.xcp_floor_name}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="textbox">
                  <label htmlFor="comboBox">Room</label>
                  <select
                    id="comboBox"
                    name="options"
                    onChange={(e) =>
                      setBEndInfo3({
                        ...bEndInfo3,
                        room: parseInt(e.target.value, 10),
                      })
                    }
                    required
                  >
                    <option value="">Select Room</option>
                    {roomsBend3.map((room) => (
                      <option key={room.xcp_room_id} value={room.xcp_room_id}>
                        {room.xcp_room_name}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="textbox">
                  <label htmlFor="rackId">Rack ID</label>
                  <input
                    type="text"
                    placeholder="L1.MMR01.04-01"
                    onChange={(e) =>
                      setBEndInfo3({ ...bEndInfo3, rackId: e.target.value })
                    }
                    required
                  />
                </div>
              </div>
            </div>
          </div>
        )}

        {/*four*/}
        {showXcp4 && (
          <div className="xcp4">
            <div className="box-two-part">
              <div className="a-end-information">
                <div className="title-box-order-input">
                  <h5>A-end Information (4)</h5>
                </div>
                <div className="textbox">
                  <label htmlFor="comboBox">Cable Type</label>
                  <select
                    id="comboBox"
                    name="options"
                    onChange={(e) =>
                      setAEndInfo4({
                        ...aEndInfo4,
                        cableType: parseInt(e.target.value, 10),
                      })
                    }
                    required
                  >
                    <option value="">Select Cable Type</option>
                    {cableTypes.map((cableType) => (
                      <option
                        key={cableType.xcp_cable_type_id}
                        value={cableType.xcp_cable_type_id}
                      >
                        {cableType.xcp_cable_type_name}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="textbox">
                  <label htmlFor="comboBox">Interface</label>
                  <select
                    id="comboBox"
                    name="options"
                    onChange={(e) =>
                      setAEndInfo4({
                        ...aEndInfo4,
                        interface: parseInt(e.target.value, 10),
                      })
                    }
                    required
                  >
                    <option value="">Select Interface</option>
                    {interfaceData.map((interfacedata) => (
                      <option
                        key={interfacedata.xcp_order_location_id}
                        value={interfacedata.xcp_interface_id}
                      >
                        {interfacedata.xcp_interface_name}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="textbox">
                  <label htmlFor="comboBox">Floor</label>
                  <select
                    id="comboBox"
                    name="options"
                    onChange={(e) => handleFloorChange(e, AEnd4)}
                    required
                  >
                    <option value="">Select Floor</option>
                    {floors.map((floor) => (
                      <option
                        key={floor.xcp_floor_id}
                        value={floor.xcp_floor_id}
                      >
                        {floor.xcp_floor_name}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="textbox">
                  <label htmlFor="comboBox">Room</label>
                  <select
                    id="comboBox"
                    name="options"
                    onChange={(e) =>
                      setAEndInfo4({
                        ...aEndInfo4,
                        room: parseInt(e.target.value, 10),
                      })
                    }
                    required
                  >
                    <option value="">Select Room</option>
                    {roomsAend4.map((room) => (
                      <option key={room.xcp_room_id} value={room.xcp_room_id}>
                        {room.xcp_room_name}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="textbox">
                  <label htmlFor="rackId">Rack ID</label>
                  <input
                    type="text"
                    placeholder="L1.MMR01.04-01"
                    onChange={(e) =>
                      setAEndInfo4({ ...aEndInfo4, rackId: e.target.value })
                    }
                    required
                  />
                </div>
                <div className="textbox">
                  <label htmlFor="cableQuantity">Cable Quantity</label>
                  <input
                    type="number"
                    min="1"
                    max="20"
                    placeholder="2"
                    onChange={(e) => {
                      const value = parseInt(e.target.value, 10);
                      if (value >= 1 && value <= 20) {
                        setAEndInfo4({
                          ...aEndInfo4,
                          cableQuantity: value,
                        });
                      } else {
                        e.target.value = ""; // Clear the input if the value is out of range
                      }
                    }}
                    required
                  />
                </div>
              </div>

              <div className="b-end-information">
                <div className="title-box-order-input">
                  <h5>B-end Information (4)</h5>
                </div>
                <div className="textbox">
                  <label htmlFor="comboBox">Cable Type</label>
                  <select
                    id="comboBox"
                    name="options"
                    onChange={(e) =>
                      setBEndInfo4({
                        ...bEndInfo4,
                        cableType: parseInt(e.target.value, 10),
                      })
                    }
                    required
                  >
                    <option value="">Select Cable Type</option>
                    {cableTypes.map((cableType) => (
                      <option
                        key={cableType.xcp_cable_type_id}
                        value={cableType.xcp_cable_type_id}
                      >
                        {cableType.xcp_cable_type_name}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="textbox">
                  <label htmlFor="comboBox">Interface</label>
                  <select
                    id="comboBox"
                    name="options"
                    onChange={(e) =>
                      setBEndInfo4({
                        ...bEndInfo4,
                        interface: parseInt(e.target.value, 10),
                      })
                    }
                    required
                  >
                    <option value="">Select Interface</option>
                    {interfaceData.map((interfacedata) => (
                      <option
                        key={interfacedata.xcp_order_location_id}
                        value={interfacedata.xcp_interface_id}
                      >
                        {interfacedata.xcp_interface_name}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="textbox">
                  <label htmlFor="comboBox">Floor</label>
                  <select
                    id="comboBox"
                    name="options"
                    onChange={(e) => handleFloorChange(e, BEnd4)}
                    required
                  >
                    <option value="">Select Floor</option>
                    {floors.map((floor) => (
                      <option
                        key={floor.xcp_floor_id}
                        value={floor.xcp_floor_id}
                      >
                        {floor.xcp_floor_name}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="textbox">
                  <label htmlFor="comboBox">Room</label>
                  <select
                    id="comboBox"
                    name="options"
                    onChange={(e) =>
                      setBEndInfo4({
                        ...bEndInfo4,
                        room: parseInt(e.target.value, 10),
                      })
                    }
                    required
                  >
                    <option value="">Select Room</option>
                    {roomsBend4.map((room) => (
                      <option key={room.xcp_room_id} value={room.xcp_room_id}>
                        {room.xcp_room_name}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="textbox">
                  <label htmlFor="rackId">Rack ID</label>
                  <input
                    type="text"
                    placeholder="L1.MMR01.04-01"
                    onChange={(e) =>
                      setBEndInfo4({ ...bEndInfo4, rackId: e.target.value })
                    }
                    required
                  />
                </div>
              </div>
            </div>
          </div>
        )}

        {/*five*/}
        {showXcp5 && (
          <div className="xcp5">
            <div className="box-two-part">
              <div className="a-end-information">
                <div className="title-box-order-input">
                  <h5>A-end Information (5)</h5>
                </div>
                <div className="textbox">
                  <label htmlFor="comboBox">Cable Type</label>
                  <select
                    id="comboBox"
                    name="options"
                    onChange={(e) =>
                      setAEndInfo5({
                        ...aEndInfo5,
                        cableType: parseInt(e.target.value, 10),
                      })
                    }
                    required
                  >
                    <option value="">Select Cable Type</option>
                    {cableTypes.map((cableType) => (
                      <option
                        key={cableType.xcp_cable_type_id}
                        value={cableType.xcp_cable_type_id}
                      >
                        {cableType.xcp_cable_type_name}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="textbox">
                  <label htmlFor="comboBox">Interface</label>
                  <select
                    id="comboBox"
                    name="options"
                    onChange={(e) =>
                      setAEndInfo5({
                        ...aEndInfo5,
                        interface: parseInt(e.target.value, 10),
                      })
                    }
                    required
                  >
                    <option value="">Select Interface</option>
                    {interfaceData.map((interfacedata) => (
                      <option
                        key={interfacedata.xcp_order_location_id}
                        value={interfacedata.xcp_interface_id}
                      >
                        {interfacedata.xcp_interface_name}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="textbox">
                  <label htmlFor="comboBox">Floor</label>
                  <select
                    id="comboBox"
                    name="options"
                    onChange={(e) => handleFloorChange(e, AEnd5)}
                    required
                  >
                    <option value="">Select Floor</option>
                    {floors.map((floor) => (
                      <option
                        key={floor.xcp_floor_id}
                        value={floor.xcp_floor_id}
                      >
                        {floor.xcp_floor_name}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="textbox">
                  <label htmlFor="comboBox">Room</label>
                  <select
                    id="comboBox"
                    name="options"
                    onChange={(e) =>
                      setAEndInfo5({
                        ...aEndInfo5,
                        room: parseInt(e.target.value, 10),
                      })
                    }
                    required
                  >
                    <option value="">Select Room</option>
                    {roomsAend5.map((room) => (
                      <option key={room.xcp_room_id} value={room.xcp_room_id}>
                        {room.xcp_room_name}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="textbox">
                  <label htmlFor="rackId">Rack ID</label>
                  <input
                    type="text"
                    placeholder="L1.MMR01.04-01"
                    onChange={(e) =>
                      setAEndInfo5({ ...aEndInfo5, rackId: e.target.value })
                    }
                    required
                  />
                </div>
                <div className="textbox">
                  <label htmlFor="cableQuantity">Cable Quantity</label>
                  <input
                    type="number"
                    placeholder="2"
                    onChange={(e) => {
                      const value = parseInt(e.target.value, 10);
                      if (value >= 1 && value <= 20) {
                        setAEndInfo5({
                          ...aEndInfo5,
                          cableQuantity: value,
                        });
                      } else {
                        e.target.value = ""; // Clear the input if the value is out of range
                      }
                    }}
                    required
                  />
                </div>
              </div>

              <div className="b-end-information">
                <div className="title-box-order-input">
                  <h5>B-end Information (5)</h5>
                </div>
                <div className="textbox">
                  <label htmlFor="comboBox">Cable Type</label>
                  <select
                    id="comboBox"
                    name="options"
                    onChange={(e) =>
                      setBEndInfo5({
                        ...bEndInfo5,
                        cableType: parseInt(e.target.value, 10),
                      })
                    }
                    required
                  >
                    <option value="">Select Cable Type</option>
                    {cableTypes.map((cableType) => (
                      <option
                        key={cableType.xcp_cable_type_id}
                        value={cableType.xcp_cable_type_id}
                      >
                        {cableType.xcp_cable_type_name}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="textbox">
                  <label htmlFor="comboBox">Interface</label>
                  <select
                    id="comboBox"
                    name="options"
                    onChange={(e) =>
                      setBEndInfo5({
                        ...bEndInfo5,
                        interface: parseInt(e.target.value, 10),
                      })
                    }
                    required
                  >
                    <option value="">Select Interface</option>
                    {interfaceData.map((interfacedata) => (
                      <option
                        key={interfacedata.xcp_order_location_id}
                        value={interfacedata.xcp_interface_id}
                      >
                        {interfacedata.xcp_interface_name}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="textbox">
                  <label htmlFor="comboBox">Floor</label>
                  <select
                    id="comboBox"
                    name="options"
                    onChange={(e) => handleFloorChange(e, BEnd5)}
                    required
                  >
                    <option value="">Select Floor</option>
                    {floors.map((floor) => (
                      <option
                        key={floor.xcp_floor_id}
                        value={floor.xcp_floor_id}
                      >
                        {floor.xcp_floor_name}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="textbox">
                  <label htmlFor="comboBox">Room</label>
                  <select
                    id="comboBox"
                    name="options"
                    onChange={(e) =>
                      setBEndInfo5({
                        ...bEndInfo5,
                        room: parseInt(e.target.value, 10),
                      })
                    }
                    required
                  >
                    <option value="">Select Room</option>
                    {roomsBend5.map((room) => (
                      <option key={room.xcp_room_id} value={room.xcp_room_id}>
                        {room.xcp_room_name}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="textbox">
                  <label htmlFor="rackId">Rack ID</label>
                  <input
                    type="text"
                    placeholder="L1.MMR01.04-01"
                    onChange={(e) =>
                      setBEndInfo5({ ...bEndInfo5, rackId: e.target.value })
                    }
                    required
                  />
                </div>
              </div>
            </div>
          </div>
        )}
        {showBtnAdd && (
          <button
            type="button"
            onClick={addNewCrossConnect}
            className="btn-add-new-cross-connect"
          >
            Add New Cross Connect
          </button>
        )}
        {showBtnRemove && (
          <button
            type="button"
            onClick={removeCrossConnect}
            className="btn-remove-cross-connect"
          >
            Remove Cross Connect
          </button>
        )}
        <input
          type="submit"
          className="btn-submit-order-input"
          value="Submit"
        />
      </form>
    </div>
  );
}

export default OrderInput;
